import React from "react";

const About = () => {
  return (
    <div className="py-20">
      <div className="container text-center ">
        <h2 className=" font-extrabold text-[30px] md:text-[90px] max-w-3xl leading-tight text-center mx-auto uppercase">
          About Us
        </h2>
        <div className="max-w-4xl mx-auto">
          <p className="font-normal mt-10">
            Through day and night exist an individual who is full of optimism
            and opportunity. Fierce and spark, his vibrations speak volume. With
            him comes hope. That is, the hope to win and persevere through any
            obstacle. His energy is obtained only through the community.
          </p>
          <p className="font-normal mt-2">
            There is a reciprocal relationship in which he provides luck and
            investors provide him with a strong established community.
          </p>
          <p className="font-normal mt-2">
            Just how he is full of good fortune, he brings with him a contagious
            type of robustness. Not only does he bring luck, but he also brings
            with him opportunity. Each and every investor has the chance to win
            a jackpot.
          </p>
          <p className="font-normal mt-2">
            Two percent of all taxes will be collected and the 50th buyer will
            receive those funds. Try your luck.
          </p>
          <p className="font-normal mt-2">
            Lucky, opportunistic, and successful he is the one and only Mozzle
            Doge.
          </p>
        </div>
      </div>
    </div>
  );
};

export default About;
